export default __webpack_public_path__ + "static/banner-01-e54452c0ca0289159fbb70ee300547d4.png";